import i18n from "../../../lang/base";
import { FONT } from "../../../value/staticValues";
import { getTimestampToDate, parseLocaleDatetime } from "../../../common/util";

import { ReactComponent as AddButtonImg } from "../../../img/ico-prefix-add.svg";
import { ReactComponent as AddButtonActiveImg } from "../../../img/ico-prefix-add-white.svg";

import { ListActionMenu, ListTableHeader } from "../../base/table/listTableType";
import { TABLE_ACTION_MENU_TYPE, TABLE_BUTTON_TYPE } from "../../../value/type";

import PodImageAdd from "./PodImageAdd";
import PodImageUpdate from "./PodImageUpdate";
import { DropdownType } from "../../base/CustomDropdown";





export interface PodImageData {
    container_image_id: string;
    container_image_name: string;
    container_image_description: string;
    container_image_version: string;
    pull_path: string;
    image_path: string;
    create_ts: string;
    update_ts: string;
    registry: {
        registry_id: string;
        registry_name: string;
    },
    project: {
        project_id: string;
        project_name: string;
    }
}


export const initPodImageData = {
    container_image_id: '',
    container_image_name: '',
    container_image_description: '',
    container_image_version: '',
    pull_path: '',
    image_path: '',
    create_ts: '',
    update_ts: '',
    registry: {
        registry_id: '',
        registry_name: '',
    },
    project: {
        project_id: '',
        project_name: '',
    }
}



export const actionMenus:ListActionMenu[] = [
    {
        id: 1,
        name: i18n.t("POD_IMAGE_CREATE_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.PUSH_WITH_ICON,
            code: "POD_IMAGE_CREATE",
            imgComponent: <AddButtonImg/> ,
            activeImgComponent: <AddButtonActiveImg />,
            inactiveImgComponent: <AddButtonImg style={{filter: "opacity(0.5) grayscale(0.5)"}}/>,
        },
    },
    {
        id: 2,
        name: i18n.t("DELETE_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.CANCEL,
            code: "POD_IMAGE_DELETE",
        },
    },{
        id: 3,
        name: i18n.t("SYNC_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.PUSH,
            code: "POD_IMAGE_SYNC",
        },
    },
];

export const tableHeaders:ListTableHeader[] = [
    {
        Header: i18n.t("IMAGE_NAME_TEXT"),
        accessor: "container_image_name",
        disableSortBy: false,
        style: {
            width: "150px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value}</div>)
    },
    {
        Header: i18n.t("POD_IMAGE_USING_ENDPOINT_TEXT"),
        accessor: "image_path",
        disableSortBy: false,
        style: {
            width: "200px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer, ...className.purpleText}}>{value}</div>)
    },
    {
        Header: i18n.t("POD_IMAGE_PULL_ENDPOINT_TEXT"),
        accessor: "pull_path",
        disableSortBy: false,
        style: {
            width: "110px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer, ...className.greenText}}>{value}</div>)
    },
    {
        Header: i18n.t("REGISTRY_NAME_TEXT"),
        accessor: "registry.registry_name",
        disableSortBy: true,
        style: {
            width: "200px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer, ...className.blueText}}>{value}</div>)
    },
    {
        Header: i18n.t("UPDATE_DATE_TEXT"),
        accessor: "update_ts",
        disableSortBy: false,
        style: {
            width: "110px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value ? parseLocaleDatetime(value) : "-"}</div>)
    },
    {
        Header: i18n.t("CREATE_DATE_TEXT"),
        accessor: "create_ts",
        disableSortBy: false,
        style: {
            width: "110px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer, ...className.dateContainer}}>{value ? parseLocaleDatetime(value) : "-"}</div>)
    },
];

export const podImageAddModalContent = {
    title: i18n.t("POD_IMAGE_CREATE_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("CREATE_TEXT")
        },
    ],
    innerComponent: <PodImageAdd />,
}

export const podImageUpdateModalContent = {
    title: i18n.t("POD_IMAGE_DETAIL_INFO_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: false,
            confirmButtonText: i18n.t("CONFIRM_TEXT")
        },
    ],
    innerComponent: <PodImageUpdate />,
}

const className = {
    statusContainer: {
        width: 56,
        display: "flex", Jusitipy: "center", justifyContent: "center",
        borderRadius: 10,
        backgroundColor: "#b6bfce",
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#fff"
    },
    statusImg: {
        marginRight: 3
    },
    normalTextContainer: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333",
        overflow: "hidden"
    },
    dateContainer: {
        color: "#9ea0a5",
    },
    greenText: {
        color: "#3a8344"
    },
    blueText: {
        color: "#0853fb"
    },
    purpleText: {
        color: "#7066f1"
    },
}